import angular from 'angular';

angular
  .module('do', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('do', {
        url: '/do/{tabName}',
        component: 'do',
        params: {
          principalIdSelected: null,
          companyIdSelected: null
        },
        resolve: {
          activeTab: [
            '$transition$',
            function($transition$) {
              return { tabName: $transition$.params().tabName };
            }
          ]
        },
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
